<script lang="ts" setup>
import UiModal from "@/ui/UiModal/UiModal.vue";
import { LANGUAGES } from "@/modules/language/constants";

import { TLangCode } from "@/modules/language/types";
import { useLanguage } from "../composables/useLanguage";
import { useLanguageStore } from "../store";

defineOptions({ name: "SwitchLanguageModal" });

const { switchLanguage } = useLanguage();
const languageStore = useLanguageStore();

const switchLangAndCloseModal = (langCode: TLangCode) => {
  switchLanguage(langCode);
  languageStore.changeSwitchLangModalState(false);
};
</script>

<template>
  <UiModal
    v-model="languageStore.isOpenSwitchLangModal"
    size="s"
    :title="$t('sys.languageSelecting')"
  >
    <template #body>
      <div class="language__outer">
        <button
          v-for="(lang, langInd) in LANGUAGES"
          :key="langInd"
          class="language"
          type="button"
          @click="switchLangAndCloseModal(lang.code)"
        >
          <div class="language__icon">
            <img :src="lang.icon" :alt="`${lang.code} icon`" />
          </div>
          <p class="language__label">{{ lang.label }}</p>
        </button>
      </div>
    </template>
  </UiModal>
</template>

<style lang="scss" scoped>
.language {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  column-gap: 12px;
  transition: background-color 0.3s;

  &:hover {
    background-color: var(--color-semantic-background-hover-primary);
  }

  &__label {
    color: var(--color-semantic-content-normal-primary);
    @include body-3-local;
  }

  &__outer {
    display: flex;
    flex-direction: column;
  }

  &__icon {
    height: 20px;
    width: 20px;
    border-radius: 100%;
    overflow: hidden;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }

  @media (max-width: 767px) {
    padding: 12px 0;
  }
}
</style>
